import PropTypes from 'prop-types'
import { map, noop } from 'lodash-es'
import HorizontalSpinner from '@components/HorizontalSpinner.tsx'

const Select = props => {
  const { id, name, className, value, options, disabled, spinWhenDisabled, onChange } = props

  const handleChange = event => {
    const {
      target: { name, value },
    } = event
    onChange({ name, value })
  }

  const getOptions = () => {
    return map(options, ({ value, text }) => {
      return (
        <option key={value} value={value}>
          {text}
        </option>
      )
    })
  }

  const progressOverlay =
    disabled && spinWhenDisabled ? (
      <div className="progress-overlay">
        <HorizontalSpinner />
      </div>
    ) : null

  // set value to an empty string if it is null
  const selectValue = value === null ? '' : value
  return (
    <div className="select-container">
      <select
        className={className}
        id={id}
        name={name}
        onChange={handleChange}
        type="text"
        value={selectValue}
        disabled={disabled}
      >
        {getOptions()}
      </select>
      {progressOverlay}
    </div>
  )
}

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  spinWhenDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

Select.defaultProps = {
  id: '',
  name: '',
  className: null,
  value: '',
  onChange: noop,
  disabled: null,
  spinWhenDisabled: false,
}

export default Select
